import { Injectable, Inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { EnvironmentConfig, ENVIRONMENT_CONFIG } from '@ipreo/northstar';
import { isEqual } from 'lodash';
import { Observable, BehaviorSubject } from 'rxjs';
import {
  map,
  tap,
  filter,
  publishReplay,
  refCount,
  distinctUntilChanged,
} from 'rxjs/operators';
import { selectSessionState } from '../state/reducer';
import { LoadSession } from '../state/session/actions';
import { SessionState } from '../state/session/state';
import { Session } from '../types/session.types';
import { PlatformType } from '../types/muni-environment';

@Injectable()
export class SessionFacade {
  public readonly session$: Observable<Session.SessionModel>;

  private platform: PlatformType;

  private buysideSub$ = new BehaviorSubject<string>(undefined);

  constructor(
    private store: Store<unknown>,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.platform = config.params.platform as PlatformType;

    if (this.platform === PlatformType.polaris) {
      this.session$ = store.pipe(
        select(selectSessionState),
        map((sessionState) => {
          if (sessionState.error) {
            throw new Error(sessionState.error);
          } else {
            return sessionState;
          }
        }),
        tap((sessionState) => this.loadSession(sessionState)),
        filter((sessionState) => !!sessionState.session),
        map((sessionState) => sessionState.session),
        publishReplay(1),
        refCount(),
        distinctUntilChanged(isEqual)
      );
    } else {
      this.session$ = this.buysideSub$.pipe(
        map(
          (sub) =>
            ({
              sub,
            } as Session.SessionModel)
        ),
        distinctUntilChanged(isEqual),
        publishReplay(1),
        refCount()
      );
    }
  }

  public setBuysideSub(id: string) {
    this.buysideSub$.next(id);
  }

  loadSession(state: SessionState) {
    if (!state.error && !state.loading && !state.loaded) {
      setTimeout(() => {
        this.store.dispatch(new LoadSession());
      }, 1);
    }
  }
}
